import axios from 'axios'
import { env } from '@/env'
import { PingTypes } from '@/app/service_layer/types/Ping.types'

export const usePingPong = () => {
  const baseUrl = process.env.REACT_APP_SERVICE_LAYER_PING ?? env.REACT_APP_SERVICE_LAYER_PING

  const pingPong = async (): Promise<PingTypes> => {
    try {
      const { data } = await axios.get(baseUrl + 'ping')
      return data
    } catch (error) {
      throw error
    }
  }

  return {
    pingPong
  }
}
